//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";
import RankingCell from "@/pages/FlashReport/components/RankingCell";
import * as d3 from 'd3';
import d3Locale from "d3-format/locale/en-US.json";

const DEFAULT_FORMAT = (value) =>
  value != null && value != undefined ? value : "N/A";

function formatNumber(num) {
  if (num !== null && num.includes(".")) {
    return d3.format(",.2f")(num);
  } else {
    return d3.format(",")(num);
  }
}

export default {
  name: "StocksTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading", "pagination"],
  components: {
    Table,
  },
  mounted: function () {
    d3Locale.thousands = " "
    d3Locale.nan = "N/A"
    d3.formatDefaultLocale(d3Locale);
  },
  data: () => ({
    separator: "horizontal",
    columns: [
      {
        name: "product-ean",
        required: false,
        label: "EAN",
        align: "left",
        field: (row) => (row.product ? row.product.ean : "N/A"),
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "product-name",
        required: false,
        label: "Descrição",
        align: "left",
        field: (row) => (row.product ? row.product.name : "N/A"),
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "product-py",
        required: false,
        label: "Vendas PY",
        align: "left",
        field: (row) => (row.sales ? formatNumber(row.sales.py) : "N/A"),
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "product-cy",
        required: false,
        label: "Vendas CY",
        align: "left",
        field: (row) => (row.sales ? formatNumber(row.sales.cy) : "N/A"),
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "product-delta",
        required: false,
        label: "Vendas CY/PY",
        align: "left",
        field: (row) => (row.sales ? row.sales.delta : "N/A"),
        format: (value) => (value != null ? `${value} %` : "N/A"),
        sortable: false,
        component: {
          element: RankingCell,
          props: {
            value: "value",
          },
        },
      },
      {
        name: "stores-py",
        required: false,
        label: "# Lojas PY",
        align: "left",
        field: (row) => (row.store_count ? row.store_count.py : "N/A"),
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "stores-cy",
        required: false,
        label: "# Lojas CY",
        align: "left",
        field: (row) => (row.store_count ? row.store_count.cy : "N/A"),
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "stores-delta",
        required: false,
        label: "# Lojas CY/PY",
        align: "left",
        field: (row) => (row.store_count ? row.store_count.delta : "N/A"),
        format: DEFAULT_FORMAT,
        sortable: false,
        component: {
          element: RankingCell,
          props: {
            value: "value",
          },
        },
      },
    ],
  }),
  methods: {},
};
